import React, { useState, useEffect } from 'react';

const HEADLINES = [
  "Sharpening pencils…",
  "Brewing the editor's coffee…",
  "Contacting sources…",
  "Verifying the facts…",
  "Clearing the press…",
  "Typesetting the front page…",
  "Consulting the style guide…",
  "Awaiting comment from all parties…",
  "Running the anti-jargon pass…",
  "Preparing the nut graf…",
];

export default function WakeUpLoader() {
  const [elapsed, setElapsed] = useState(0);
  const [headlineIndex, setHeadlineIndex] = useState(0);
  const [dots, setDots] = useState('');
  const [showWakeUp, setShowWakeUp] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setElapsed(s => s + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (elapsed >= 2) setShowWakeUp(true);
  }, [elapsed]);

  useEffect(() => {
    if (!showWakeUp) return;
    const interval = setInterval(() => {
      setHeadlineIndex(i => (i + 1) % HEADLINES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [showWakeUp]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(d => d.length >= 3 ? '' : d + '.');
    }, 400);
    return () => clearInterval(interval);
  }, []);

  // progress: saturates at ~60s (typical Render cold start ceiling)
  const progress = Math.min((elapsed / 60) * 100, 95);

  if (!showWakeUp) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-muted-foreground text-sm">Loading{dots}</div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="flex flex-col items-center gap-6 max-w-sm w-full px-8">

        {/* Masthead */}
        <div className="text-center">
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-1">
            The Journalist's Lab
          </div>
          <div
            className="text-2xl font-bold tracking-tight"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            PRESS IN PROGRESS
          </div>
          <div className="text-xs text-muted-foreground mt-1 border-t border-b border-muted-foreground/30 py-1">
            Server waking up — cold start on free tier
          </div>
        </div>

        {/* Rotating headline */}
        <div
          key={headlineIndex}
          className="text-sm text-center text-foreground/80 italic min-h-[1.5rem] transition-all duration-500"
          style={{ fontFamily: 'Georgia, serif' }}
        >
          {HEADLINES[headlineIndex]}
        </div>

        {/* Progress bar — newspaper column style */}
        <div className="w-full">
          <div className="flex justify-between text-xs text-muted-foreground mb-1">
            <span>DEADLINE</span>
            <span>{elapsed}s</span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-foreground rounded-full transition-all duration-1000 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-xs text-muted-foreground text-center mt-2">
            {elapsed < 15
              ? "Usually ready in 20–40 seconds"
              : elapsed < 35
              ? "Almost there — presses take time"
              : "Any moment now…"}
          </div>
        </div>

        {/* Byline */}
        <div className="text-xs text-muted-foreground/50 text-center">
          Render free tier · cold start · worth the wait
        </div>
      </div>
    </div>
  );
}
